import { formatTime, longFormatTime, shortTime, timeBefore, playTime, timeAndViews } from '../../utils/date';

const VueDatetimeFilter = {
    install(Vue) {
        Vue.filter('formatTime', formatTime);
        Vue.filter('longFormatTime', longFormatTime);
        Vue.filter('shortTime', shortTime);
        Vue.filter('timeBefore', timeBefore);
        Vue.filter('playTime', playTime);
        Vue.filter('timeAndViews', timeAndViews);
    }
};

export default VueDatetimeFilter;
